

const flashSale = {
    currentPage: 1,  // 当前页码
    pageSize: 20,    // 每页显示数量
    totalProducts: 0, // 总产品数
    allProductIds: [], // 所有产品ID
    init() {
        this.getProductSalesData()

    },
    // 显示加载动画
    showLoading() {
        // 查找目标容器
        const collectionResult = document.querySelector('#CollectionAjaxResult')
        if (!collectionResult) return

        // 查找或创建 loading 容器
        let loadingContainer = collectionResult.querySelector('.flash-sale-loading')
        if (!loadingContainer) {
            loadingContainer = document.createElement('div')
            loadingContainer.className = 'flash-sale-loading'
            loadingContainer.innerHTML = `
                <div class="flash-sale-loading-overlay">
                    <div class="flash-sale-spinner">
                        <svg class="spinner" width="65px" height="65px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                            <circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
                        </svg>
                        <span class="loading-text">Loading...</span>
                    </div>
                </div>
            `
            collectionResult.appendChild(loadingContainer)

            // 确保容器有相对定位
            if (getComputedStyle(collectionResult).position === 'static') {
                collectionResult.style.position = 'relative'
            }

            // 添加样式
            if (!document.getElementById('flash-sale-loading-styles')) {
                const style = document.createElement('style')
                style.id = 'flash-sale-loading-styles'
                style.textContent = `
                    .flash-sale-loading {
                        position: absolute;
                        top: 0;
                        left: 0;
                        width: 100%;
                        height: 100%;
                        min-height: 400px;
                        z-index: 100;
                        display: none;
                    }
                    .flash-sale-loading.active {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                    }
                    .flash-sale-loading-overlay {
                        position: absolute;
                        top: 0;
                        left: 0;
                        width: 100%;
                        height: 100%;
                        background: rgba(255, 255, 255, 0.9);
                        display: flex;
                        align-items: center;
                        justify-content: center;
                    }
                    .flash-sale-spinner {
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        gap: 15px;
                    }
                    .flash-sale-spinner .spinner {
                        animation: rotator 1.4s linear infinite;
                    }
                    @keyframes rotator {
                        0% { transform: rotate(0deg); }
                        100% { transform: rotate(270deg); }
                    }
                    .flash-sale-spinner .path {
                        stroke-dasharray: 187;
                        stroke-dashoffset: 0;
                        transform-origin: center;
                        stroke: #000;
                        animation: dash 1.4s ease-in-out infinite;
                    }
                    @keyframes dash {
                        0% { stroke-dashoffset: 187; }
                        50% {
                            stroke-dashoffset: 46.75;
                            transform: rotate(135deg);
                        }
                        100% {
                            stroke-dashoffset: 187;
                            transform: rotate(450deg);
                        }
                    }
                    .flash-sale-spinner .loading-text {
                        font-size: 16px;
                        font-weight: 600;
                        color: #000;
                        letter-spacing: 0.5px;
                    }
                `
                document.head.appendChild(style)
            }
        }
        loadingContainer.classList.add('active')
    },
    // 隐藏加载动画
    hideLoading() {
        const collectionResult = document.querySelector('#CollectionAjaxResult')
        if (!collectionResult) return

        const loadingContainer = collectionResult.querySelector('.flash-sale-loading')
        if (loadingContainer) {
            loadingContainer.classList.remove('active')
        }
    },
    // 从URL获取页码参数
    getPageFromUrl() {
        const urlParams = new URLSearchParams(window.location.search)
        const page = parseInt(urlParams.get('page'))
        return page && page > 0 ? page : 1
    },
    // 更新URL页码参数
    updateUrlPage(page) {
        const urlParams = new URLSearchParams(window.location.search)
        if (page === 1) {
            urlParams.delete('page')
        } else {
            urlParams.set('page', page)
        }
        const newUrl = urlParams.toString() ?
            `${window.location.pathname}?${urlParams.toString()}` :
            window.location.pathname
        return newUrl
    },
    setIntervalFn(time) {
        // 设置倒计时的目标日期和时间
        const targetDate = time;
        let node = document.getElementById("product-single__countdown");
        // 每一秒更新倒计时
        const countdown = setInterval(function () {
            // 获取当前日期和时间
            const now = new Date().getTime();

            // 计算目标日期和当前日期的时间差
            const timeDifference = targetDate - now;

            // 计算剩余的小时、分钟和秒数
            const hours = Math.floor(timeDifference / (1000 * 60 * 60));
            const minutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));
            const seconds = Math.floor((timeDifference % (1000 * 60)) / 1000);

            // 将剩余时间显示在页面上
            node.innerHTML = `
                    <div class="text-lighter product-single__countdown_container">
                        <div class=" product-single__countdown-item-text">
                            Limited time deal
                        </div>
                        <div class="product-single__countdown-item-time">
                            <span style="margin-right: 10px;">Ends in</span>     
                            <span class='time-detail'>${hours}</span> : 
                            <span class='time-detail'>${minutes}</span> : 
                            <span class='time-detail'>${seconds}</span>
                        </div>
                    </div>
                    `
            // 倒计时结束
            if (timeDifference < 0) {
                clearInterval(countdown);
            }
        }, 1000);

    },

    badgeSvg(config) {
        // 处理折扣文本
        let badgeText = config.text.trim();
        if (badgeText.includes('{discount-number}')) {
            const discountValue = config.discountType === 'percentage'
                ? `${config.discountValue}%`
                : `$${parseFloat(config.discountValue).toFixed(2)}`;
            badgeText = badgeText.replace('{discount-number}', discountValue);
        }

        // 分割文本（如果有空格，分成两行）
        const textParts = badgeText.split(' ');
        const line1 = textParts[0] || '';
        const line2 = textParts.slice(1).join(' ') || '';

        // 生成唯一的渐变 ID
        const gradientId = 'grad-' + Math.random().toString(36).substr(2, 9);

        // 根据模板类型返回不同的 SVG
        // 这里先使用 badge-img-4 的形状作为默认
        return `
        <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 80 80" fill="none">
          <path d="M0 40C0 35.7328 4.82857 32.316 6.02143 28.4665C7.26429 24.4828 5.30714 18.7683 7.63571 15.441C9.96429 12.1138 15.8 12.2555 19.0071 9.81606C22.2143 7.37658 23.8143 1.55017 27.6357 0.259552C31.3214 -0.99376 35.9143 2.69904 40 2.69904C44.0857 2.69904 48.6786 -0.99376 52.3643 0.259552C56.1857 1.55017 57.8143 7.39896 60.9929 9.81606C64.1714 12.2332 70.0286 12.0541 72.3643 15.441C74.7 18.828 72.7357 24.4828 73.9786 28.4665C75.1714 32.316 80 35.7328 80 40C80 44.2672 75.1714 47.684 73.9786 51.5335C72.7357 55.5172 74.6929 61.2317 72.3643 64.559C70.0357 67.8862 64.2 67.737 60.9929 70.1839C57.7857 72.6309 56.1857 78.4498 52.3643 79.7404C48.6786 80.9938 44.0857 77.301 40 77.301C35.9143 77.301 31.3214 80.9938 27.6357 79.7404C23.8143 78.4498 22.1857 72.5936 19.0071 70.1765C15.8286 67.7594 10 67.8862 7.63571 64.559C5.27143 61.2317 7.26429 55.5172 6.02143 51.5335C4.82857 47.684 0 44.2672 0 40Z" fill="url(#${gradientId})"></path>
          
          ${line2 ? `
          <text font-size="${config.fontSize}px" x="50%" y="40%" text-anchor="middle" dominant-baseline="middle" fill="${config.textColor}" font-weight="800">
            ${line1}
          </text>
          <text font-size="${config.fontSize}px" x="50%" y="65%" text-anchor="middle" dominant-baseline="middle" fill="${config.textColor}" font-weight="800">
            ${line2}
          </text>
          ` : `
          <text font-size="${config.fontSize}px" x="50%" y="50%" text-anchor="middle" dominant-baseline="middle" fill="${config.textColor}" font-weight="800">
            ${line1}
          </text>
          `}
      
          <defs>
            <linearGradient id="${gradientId}" x1="40" y1="4.19107" x2="40" y2="81.7771" gradientUnits="userSpaceOnUse">
              <stop stop-color="${config.bgSolid}"></stop>
              ${config.bgFilled === 'gradient' ? `<stop offset="1" stop-color="${config.bgGradient}"></stop>` : ''}
            </linearGradient>
          </defs>
        </svg>
        `;
    },
    getProductSalesData(type, node) {
        // 显示加载动画
        this.showLoading()

        fetch("https://ohwillfinds.com/apps/wizzsaleplus",
            {
                method: 'post', body: JSON.stringify({
                    "data": { "customer_info": "null" },
                    "action": "getAppConfig"
                })
            }).then(res => res.json()).then(data => {
                // 集合页
                if (data.fs_active) {
                    let productData = data.fs_active.product_data  // 产品数据
                    let flashKeys = Object.keys(productData)

                    // 保存所有产品ID和总数
                    this.allProductIds = flashKeys
                    this.totalProducts = flashKeys.length

                    // 从URL读取页码，如果没有则默认为第一页
                    const initialPage = this.getPageFromUrl()
                    this.loadPage(initialPage, productData)
                    document.querySelector('.text-no-matches').style.display = 'none'
                } else {
                    // 如果没有数据，隐藏 loading
                    this.hideLoading()
                    document.querySelector('.text-no-matches').style.display = 'block'
                }

            }).catch(error => {
                console.error('Failed to load flash sale data:', error)
                this.hideLoading()
            })
    },
    loadPage(pageNumber, productData) {
        // 显示加载动画
        this.showLoading()

        // 计算当前页的产品ID范围
        const startIndex = (pageNumber - 1) * this.pageSize
        const endIndex = Math.min(startIndex + this.pageSize, this.totalProducts)
        const pageProductIds = this.allProductIds.slice(startIndex, endIndex)

        // 构建搜索查询
        const product_ids = pageProductIds.map(item => `id:${item}`).join(' OR ')

        fetch(`/search?type=product&q=${product_ids}`)
            .then(res => res.text())
            .then(data => {
                const dataHtml = new DOMParser().parseFromString(data, 'text/html');
                const collectionSection = document.querySelector('.collection-template-flashSale-grid');
                if (!collectionSection) {
                    this.hideLoading()
                    return;
                }
                collectionSection.innerHTML = dataHtml.querySelector('.search-grid').innerHTML

                // 修改产品链接，在href前面添加当前路径
                this.updateProductLinks(collectionSection);

                // 增加元素
                this.addElement(collectionSection);
                // 增加svg
                this.addSvg(collectionSection, productData)

                // 重新初始化产品卡片的事件（快速添加、快速预览等）
                this.reinitializeProductEvents(collectionSection);

                // 更新当前页码
                this.currentPage = pageNumber


                const newUrl = this.updateUrlPage(pageNumber)
                window.history.pushState({ page: pageNumber }, '', newUrl)

                // 渲染分页控件
                this.renderPagination()

                // 隐藏加载动画
                this.hideLoading()

                // 滚动到页面顶部
                // window.scrollTo({ top: 0, behavior: 'smooth' });
            })
            .catch(error => {
                console.error('Failed to load products:', error)
                this.hideLoading()
            });
    },
    renderPagination() {
        // 计算总页数
        const totalPages = Math.ceil(this.totalProducts / this.pageSize)

        // 如果只有一页或没有产品，不显示分页
        if (totalPages <= 1) {
            const existingPagination = document.querySelector('.flash-sale-pagination')
            if (existingPagination) {
                existingPagination.remove()
            }
            return
        }

        // 查找或创建分页容器
        let paginationContainer = document.querySelector('.flash-sale-pagination')
        if (!paginationContainer) {
            paginationContainer = document.createElement('div')
            paginationContainer.className = 'flash-sale-pagination'
            const collectionSection = document.querySelector('.collection-template-flashSale-grid')
            if (collectionSection && collectionSection.parentNode) {
                collectionSection.parentNode.insertBefore(paginationContainer, collectionSection.nextSibling)
            }
        }

        // 使用 Shopify 原生分页样式
        let paginationHTML = '<div class="pagination">'

        // 上一页按钮
        if (this.currentPage > 1) {
            const prevUrl = this.updateUrlPage(this.currentPage - 1)
            paginationHTML += `
                <span class="prev">
                    <a href="${prevUrl}" title="Previous" class="btn btn--large btn--circle btn--icon">
                        <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-left" viewBox="0 0 284.49 498.98"><path d="M249.49 0a35 35 0 0 1 24.75 59.75L84.49 249.49l189.75 189.74a35.002 35.002 0 1 1-49.5 49.5L10.25 274.24a35 35 0 0 1 0-49.5L224.74 10.25A34.89 34.89 0 0 1 249.49 0z"></path></svg>
                        <span class="icon__fallback-text">Previous</span>
                    </a>
                </span>
            `
        }

        // 页码
        for (let i = 1; i <= totalPages; i++) {
            if (i === this.currentPage) {
                paginationHTML += `<span class="page current">${i}</span>`
            } else {
                const pageUrl = this.updateUrlPage(i)
                paginationHTML += `<span class="page"><a href="${pageUrl}">${i}</a></span>`
            }
        }

        // 下一页按钮
        if (this.currentPage < totalPages) {
            const nextUrl = this.updateUrlPage(this.currentPage + 1)
            paginationHTML += `
                <span class="next">
                    <a href="${nextUrl}" title="Next" class="btn btn--large btn--circle btn--icon">
                        <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-right" viewBox="0 0 284.49 498.98"><path d="M35 498.98a35 35 0 0 1-24.75-59.75l189.74-189.74L10.25 59.75a35.002 35.002 0 0 1 49.5-49.5l214.49 214.49a35 35 0 0 1 0 49.5L59.75 488.73A34.89 34.89 0 0 1 35 498.98z"></path></svg>
                        <span class="icon__fallback-text">Next</span>
                    </a>
                </span>
            `
        }

        paginationHTML += '</div>'

        paginationContainer.innerHTML = paginationHTML
    },
    addSvg(container, productData) {
        // 检查是否存在 _wsale 配置和徽章数据
        if (typeof _wsale === 'undefined' || !_wsale.sale_campaigns || !_wsale.sale_campaigns.length) {
            return;
        }

        const campaigns = _wsale.sale_campaigns;

        container.querySelectorAll('.grid-product').forEach(productItem => {
            let productId = (productItem.getAttribute('data-product-id'))
            let productPrice = (productItem.getAttribute('data-price'))
            let productCompareAtPrice = (productItem.getAttribute('data-compare-at-price'))
            let discountValue = 0
            let discountType = 'amount'
            if (!Number(productCompareAtPrice)) return;
            if (productPrice && Number(productCompareAtPrice) > Number(productPrice)) {
                discountValue = Math.round(((Number(productCompareAtPrice) - Number(productPrice)) / Number(productCompareAtPrice)) * 100);
                discountType = 'percentage';
            }
            let productObj = productData[productId]
            let product_campaign_id = undefined
            for (let variant in productObj[0]) {
                product_campaign_id = productObj[0][variant].campaign_id
                if (product_campaign_id) {
                    break
                }
            }
            let pro_campaign = campaigns.find(item => item.id_campaign == product_campaign_id)
            _wsale.sale_campaigns.forEach(campaign => {
                if (campaign.id_campaign == pro_campaign.id_campaign) {

                    // 检查是否有徽章配置
                    if (!campaign.has_badge || !campaign.badge_data) {
                        return;
                    }

                    const badgeData = campaign.badge_data;
                    const selectedTemplate = badgeData.selected_template; // 例如: 'badge-img-4'

                    if (!selectedTemplate) {
                        return;
                    }
                    // 获取徽章配置
                    const badgeConfig = {
                        template: selectedTemplate,
                        text: badgeData.badge_text || '',
                        fontSize: badgeData.badge_font_size || 16,
                        position: badgeData.badge_position || 'top-left',
                        bgFilled: badgeData.badge_bg_filled || 'gradient',
                        bgSolid: badgeData.badge_bg_solid || '#FF223E',
                        bgGradient: badgeData.badge_bg_gradient || '#B5182C',
                        textColor: badgeData.badge_text_color || '#FFFFFF',
                        discountValue: discountValue || 0,
                        discountType: discountType || 'amount'
                    };

                    // 获取对应的 SVG 模板
                    const svgTemplate = this.badgeSvg(badgeConfig);

                    if (!svgTemplate) {
                        return;
                    }


                    // 检查是否已经添加过徽章
                    if (productItem.querySelector('.flash-sale-badge')) {
                        return;
                    }

                    // 创建徽章容器
                    const badgeWrapper = document.createElement('div');
                    badgeWrapper.className = 'flash-sale-badge';
                    badgeWrapper.style.cssText = `position: absolute; ${badgeConfig.position.includes('top') ? 'top' : 'bottom'}: 0px; ${badgeConfig.position.includes('left') ? 'left' : 'right'}: 0px; z-index: 10;`;
                    badgeWrapper.innerHTML = svgTemplate;

                    // 将徽章添加到产品卡片中（通常在产品图片容器内）
                    const imageWrapper = productItem.querySelector('.grid-product__image-wrap');
                    if (imageWrapper) {
                        // 确保图片容器有相对定位
                        imageWrapper.style.position = 'relative';
                        imageWrapper.appendChild(badgeWrapper);
                    }

                }
            })
        })
        // 遍历所有 campaign
        // campaigns.forEach(campaign => {
        //     // 检查是否有徽章配置
        //     if (!campaign.has_badge || !campaign.badge_data) {
        //         return;
        //     }

        //     const badgeData = campaign.badge_data;
        //     const selectedTemplate = badgeData.selected_template; // 例如: 'badge-img-4'

        //     if (!selectedTemplate) {
        //         return;
        //     }
        //     // 获取徽章配置
        //     const badgeConfig = {
        //         template: selectedTemplate,
        //         text: badgeData.badge_text || '',
        //         fontSize: badgeData.badge_font_size || 16,
        //         position: badgeData.badge_position || 'top-left',
        //         bgFilled: badgeData.badge_bg_filled || 'gradient',
        //         bgSolid: badgeData.badge_bg_solid || '#FF223E',
        //         bgGradient: badgeData.badge_bg_gradient || '#B5182C',
        //         textColor: badgeData.badge_text_color || '#FFFFFF',
        //         discountValue: campaign.discount_value || 0,
        //         discountType: campaign.discount_type || 'amount'
        //     };

        //     // 获取对应的 SVG 模板
        //     const svgTemplate = this.badgeSvg(badgeConfig);

        //     if (!svgTemplate) {
        //         return;
        //     }

        //     // 获取该 campaign 的产品 ID 列表
        //     const triggerProductIds = campaign.trigger_products ?
        //         campaign.trigger_products.map(p => p.id) : [];

        //     // 查找所有产品卡片
        //     const productItems = container.querySelectorAll('.grid-product');

        //     productItems.forEach(productItem => {
        //         // 获取产品 ID
        //         const productId = productItem.getAttribute('data-product-id');

        //         // 检查该产品是否在当前 campaign 的触发产品列表中
        //         if (!triggerProductIds.includes(productId)) {
        //             return;
        //         }

        //         // 检查是否已经添加过徽章
        //         if (productItem.querySelector('.flash-sale-badge')) {
        //             return;
        //         }

        //         // 创建徽章容器
        //         const badgeWrapper = document.createElement('div');
        //         badgeWrapper.className = 'flash-sale-badge';
        //         badgeWrapper.style.cssText = `position: absolute; ${badgeConfig.position.includes('top') ? 'top' : 'bottom'}: 0px; ${badgeConfig.position.includes('left') ? 'left' : 'right'}: 0px; z-index: 10;`;
        //         badgeWrapper.innerHTML = svgTemplate;

        //         // 将徽章添加到产品卡片中（通常在产品图片容器内）
        //         const imageWrapper = productItem.querySelector('.grid-product__image-wrap');
        //         if (imageWrapper) {
        //             // 确保图片容器有相对定位
        //             imageWrapper.style.position = 'relative';
        //             imageWrapper.appendChild(badgeWrapper);
        //         }
        //     });

        // });
    },
    updateProductLinks(container) {
        const currentPath = window.location.pathname;
        const collectionMatch = currentPath.match(/\/collections\/([^\/]+)/);

        if (!collectionMatch) {
            return;
        }

        const collectionHandle = collectionMatch[1];

        // 查找所有产品链接并添加 collection 参数
        const productLinks = container.querySelectorAll('.grid-item__link');

        productLinks.forEach(link => {
            const originalHref = link.getAttribute('href');
            // 如果是产品链接
            if (originalHref && originalHref.includes('/products/')) {
                // 添加 collection 参数让 Shopify 知道来源集合
                const separator = originalHref.includes('?') ? '&' : '?';
                const newHref = `${originalHref}${separator}collection=${collectionHandle}`;
                link.setAttribute('href', newHref);
            }
        });

        // 同时更新 data-url 属性（用于颜色切换等）
        const elementsWithDataUrl = container.querySelectorAll('[data-url]');
        elementsWithDataUrl.forEach(element => {
            const originalUrl = element.getAttribute('data-url');
            if (originalUrl && originalUrl.includes('/products/')) {
                const separator = originalUrl.includes('?') ? '&' : '?';
                const newUrl = `${originalUrl}${separator}collection=${collectionHandle}`;
                element.setAttribute('data-url', newUrl);
            }
        });

    },
    addElement(container) {
        // 给每个产品卡片的价格区域下方添加"Limited time deal"标签
        const priceWraps = container.querySelectorAll('.product__price-wrap');

        priceWraps.forEach(priceWrap => {
            // 检查是否已经在下方添加过标签，避免重复
            const nextElement = priceWrap.nextElementSibling;
            if (!nextElement || !nextElement.classList.contains('limitedLable')) {
                // 创建标签元素
                const limitedLabel = document.createElement('span');
                limitedLabel.className = 'limitedLable';
                limitedLabel.textContent = 'Limited time deal';

                // 将标签插入到价格区域的下方（外部）
                priceWrap.insertAdjacentElement('afterend', limitedLabel);
            }
        });

    },
    reinitializeProductEvents(container) {
        // 重新初始化主题的QuickAdd和QuickShop功能
        try {
            // 检查theme对象是否存在
            if (typeof theme !== 'undefined') {
                // 重新初始化QuickAdd按钮事件
                if (theme.QuickAdd) {
                    new theme.QuickAdd(container);
                }

                // 重新初始化QuickShop按钮事件
                if (theme.QuickShop) {
                    new theme.QuickShop(container);
                }

                // 重新初始化全局功能（如果有的话）
                if (theme.initGlobals) {
                    theme.initGlobals();
                }
            }

            // 如果使用AOS动画库，刷新动画
            if (window.AOS) {
                AOS.refreshHard();
            }

            // 触发自定义事件，通知其他脚本产品已加载
            document.dispatchEvent(new CustomEvent('flashsale:productsLoaded', {
                detail: { container: container }
            }));

        } catch (error) {

        }
    }
}



flashSale.init();